export default __webpack_public_path__ + "static/media/BowstringTrussImg.cab738f5.png";